<!-- src/app/pages/companies-v2.component/companies-v2.component.html -->
<div class="companies-container">
  <div class="container-left">
    <div class="logo" (click)="baseService.toPreview()">
      <img class="logo-icon" src="/assets/svgs/logos/Logo_JE_128x420_primary.svg" alt="logo-of-JECRM" />
    </div>
  </div>

  <div class="container-right">
    <mat-card class="b24-card" appearance="outlined" role="dialog" aria-labelledby="b24Title">
      <h2 class="title">{{ 'your_JECRM' | translate }}</h2>

      <div class="sec">
        <div class="label">{{ 'your_account' | translate }}</div>
        <div class="acc">
          <div class="avatar">
            <img
              [src]="baseService.user.avatar_url || '/assets/svgs/special/profile.svg'"
              alt="logo"
            />
          </div>
          <div class="email" [title]="baseService.user.email">{{ baseService.user.email }}</div>
        </div>
      </div>

      <div class="sec">
        <div class="label">{{ 'companies' | translate }}:</div>

        @if (isLoader()) {
          <div class="loader">
            <app-loader size="small"></app-loader>
          </div>
        } @else {
          @for (c of companies(); track c.subdomain; let last = $last) {
            <div class="row" (click)="onSelectCompany(c.subdomain)">
              <div class="left">
                <span>{{ c.name }}</span>
                <span>{{ c.subdomain }}.{{ environment.web_url }}</span>
                <app-button>{{ 'login' | translate }}</app-button>
              </div>

              @if (!last) {
                <mat-divider></mat-divider>
              }

            </div>
          }
        }

      </div>

      @if (isCreateCompany) {
        @if (!baseService.user.referral_code) {
          <app-input
            [label]="'have_promo_code' | translate"
            labelColor="#000"
            [ngModel]="promoCode()"
            (ngModelChange)="promoCode.set($event)"
          ></app-input>
        } @else {
          <div class="text-sm text-black">
            {{ 'working_by_referral' | translate: { code: baseService.user.referral_code } }}
          </div>
        }
        <app-button [full]="true" (click)="createCompany()">{{ 'create_company' | translate }}</app-button>
      }
      <app-button btnType="stroked" [full]="true" (click)="logout()" >{{ 'exit' | translate }}</app-button>
    </mat-card>
  </div>
</div>
